import React from "react";

export const ComingFeaturesPage = () => {
  return (
    <div className="table-of-contents" style={{ width: "80%", padding: "15px" }}>
      <h1>Coming Features</h1>
      <div>
        <p>Oceanflowz International Beauty World App is under construction for Apple &amp; Android to be fully functional for client services &amp; members.</p>
        <p>The app is for scheduling payments, member availability and bios worldwide. Development process is to be completed by the Summer &amp; Winter months of 2020 when advertisement campaigns for client and complete exposure state &amp; worldwide begin.</p>
        <div style={{ textAlign: "initial" }}>
          <span>Advertisements will be via:</span>
          <ol>
            <li>Internet</li>
            <li>Billboard</li>
            <li>Newspaper</li>
            <li>TV/Radio commercials</li>
            <li>Social Media</li>
            <li>Seminars</li>
          </ol>
        </div>
        <p>The aim will be state &amp; worldwide on a constant basis to ensure our success.</p>
        <p>Thank you again for all who considered this opportunity and remember "teamwork will make all of our biggest dreams work!"</p>
        <p>Contact us for any questions or concerns</p>
        <p>267-752-3322 Field</p>
        <p>267-338-3300 Office</p>
        <div style={{ textAlign: "initial", marginBottom: '10px' }}>
          <a href="mailto:management@ocnflwzint.com">management@ocnflwzint.com</a>
        </div>
        <address>
          1500 Market St 12th Floor
          East Tower Philadelphia, PA 19102
        </address>
      </div>
    </div>
  );
};
